import everything from '@/store/modules/dashboard/my-posts/everything';
import drafts from '@/store/modules/dashboard/my-posts/drafts';
import published from '@/store/modules/dashboard/my-posts/published';
import subscribers from '@/store/modules/dashboard/my-posts/subscribers';
import socials from '@/store/modules/dashboard/my-posts/socials';
import notes from '@/store/modules/dashboard/my-posts/notes';

export default {
  namespaced: true,
  modules: {
    everything,
    drafts,
    published,
    subscribers,
    socials,
    notes,
  },
};
